import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
    ...zhLocale,
    logs: {
        processor: "处理器及内存信息",
        custom_list_prompts: "当前数据1分钟刷新一次,数字为红色代表有新增数据。",
        immediate_delivery: '立即投递',
        transmit: '转发',
        transmit_send: '发送',
        menu_judge: '目录权限',
        // 携程单独配置
        ctrip1: '启用正文恶意超链接防护',
        ctrip2: '隔离访问域名',
        ctrip3: 'IP地址/网段',
        ctrip4: '邮件账号或IP地址',
        // 携程单独配置 end 

        // 域管理员 (代理商)
        domain_1: '到期日期',
        domain_2: '所属代理商',
        domain_3: '域列表',
        domain_4: '新建域',
        domain_5: '编辑域',
        domain_6: '域查询',
        domain_7: '创建日期范围',
        domain_8: '到期日期范围',
        domain_9: '更改域名',
        domain_10: '原有域名',
        domain_11: '更改所属代理',
        domain_12: '设置邮件搬家',


        agent2: '代理商',
        agent3: '已用/可用域',
        agent4: '已用/可用空间(M)',
        agent5: '已用/可用用户',
        agent6: '已用/可用网盘(M)',
        agent7: '增加代理商',
        agent8: '代理商名称',
        agent9: '最大允许域',
        agent10: '联系人',
        agent11: '备注',
        agent12: '网站',
        agent13: '权限控制',
        agent14: '允许删除域',
        agent15: '允许设置附件大小',
        agent16: '允许增加域空间、用户数等功能',
        agent17: '允许减少域空间、用户数等功能',
        agent18: '安全邮件',
        agent19: '企业地址簿',
        agent20: '语音邮件',
        agent21: '视频邮件',
        agent22: '短信息',
        agent23: '彩信',
        agent24: 'WAP',
        agent25: '打印',
        agent26: '邮件监控',
        agent27: '邮件列表',
        agent28: '允许创建下级代理商',
        agent29: 'POP3',
        agent30: '域别名列表',
        agent31: '添加域别名',
        agent32: '域别名',
        agent33: '目标域',


        // 域管理员 (代理商) end
        // 域管理员 (用户)
        // 管理模式
        mode_switch1: '管理模式切换',
        mode_switch2: '当前模式',
        mode_switch3: '管理员密码',
        mode_switch4: '隔离管理',
        mode_switch5: '正常邮件',
        mode_switch6: '日志管理',
        mode_switch7: '策略配置',
        mode_switch8: '审核管理',
        mode_switch100: '是否只读',
        mode_switch9: '设置角色管理对象',
        mode_switch91: '设置角色管理对象',
        mode_switch92: '该角色可管理部门',

        mode_switch10: '将角色赋予用户',
        mode_switch11: '该角色可管理用户',
        mode_switch12: '设定拥有该角色用户',
        mode_switch13: '用户设置',
        mode_switch14: '普通用户默认',
        mode_switch15: '设置普通用户默认情况下是否允许登录管理后台',
        mode_switch16: '用户列表',
        mode_switch17: '用户类型',
        mode_switch18: '登录类型',

        // 管理模式 end 
        // 角色管理
        role1: '角色列表',
        role2: '角色名',
        role3: '创建角色',
        role4: '设置老板',
        role5: '修改角色',
        role6: '角色权限设置',
        role7: '查看员工邮件快照',
        role8: '查看归档邮件',
        role9: '下载归档邮件',
        role10: '从归档中恢复邮件',
        // 定制管理
        customize1: '界面定制',
        customize2: '首页定制url',
        customize3: '退出定制url',
        customize4: 'logo img',
        customize5: '广告定制',
        customize6: '设定写信信尾自动包含广告',
        customize7: 'HTML源代码',
        customize8: '文本格式',
        customize9: '内容',
        // 定制管理 end 
        // 监控列表
        monitor_list1: '监控列表',
        monitor_list2: '被监控对象',
        monitor_list3: '备份目标邮箱',
        monitor_list4: '新增监控',
        monitor_list5: '编辑监控列表',
        // 监控列表 end

        // 别名列表
        alias_list1: '别名列表',
        alias_list2: '别名',
        alias_list3: '目标地址',
        alias_list4: '增加别名',
        alias_list5: '编辑别名列表',
        // 别名列表 end
        // 邮件限制列表
        mail_limit1: '邮件限制列表',
        mail_limit2: '新增邮件限制',
        mail_limit3: '被限制用户',
        mail_limit4: '限制发送',
        mail_limit5: '限制接收',
        mail_limit6: '编辑邮件限制',
        mail_limit7: '高级设置',
        mail_limit8: '仅对指定域限制',
        mail_limit9: '排除指定域限制',
        // 邮件限制列表 end
        // 群发邮件
        group_sending1: '说明',
        group_sending2: '发送',
        group_sending3: '发给全体用户',
        group_sending4: '发给指定部门',
        group_sending5: '群发邮件',
        // 群发邮件 end
        // 邮件管理
        mail_list1: '邮件列表',
        mail_list2: '新增邮件列表',
        mail_list3: '编辑邮件列表',
        mail_list4: '邮件列表类型',
        mail_list5: '列表管理',
        mail_list6: '授权用户',
        mail_list7: '增加内部邮箱',
        mail_list8: '增加外部邮箱',
        mail_list9: '增加部门',
        // 邮件管理  end

        // 创建用户
        create_user1: "创建用户",
        create_user2: "性别",
        create_user3: "是否vip",
        create_user4: "禁用规则",
        create_user5: "职务",
        create_user6: "工号",
        create_user7: "查询密码问题",
        create_user8: "查询密码答案",
        create_user9: "最近登录时间",
        create_user10: "最近登录ip",
        create_user11: "基本信息",
        create_user12: "公司",
        create_user13: "座机",
        create_user14: "省份",
        create_user15: "城市",
        create_user16: "手机",
        create_user17: "传真",
        create_user18: "邮编",
        create_user19: "联系地址",
        create_user20: "上传并创建用户",
        // 创建用户 end

        // 用户管理
        user_list_manage1: '最大用户数',
        user_list_manage2: '已分配用户数',
        user_list_manage3: '剩余用户数',
        user_list_manage4: '最大空间',
        user_list_manage5: '已分配空间',
        user_list_manage6: '剩余空间',
        user_list_manage7: '最大网络磁盘(M)',
        user_list_manage8: '已分配网络磁盘',
        user_list_manage9: '剩余网络磁盘',
        user_list_manage10: '批量删除',
        user_list_manage11: '分配部门:',
        user_list_manage12: '批量激活',
        user_list_manage13: '批量停止',
        user_list_manage14: '取消管理员',
        user_list_manage15: '设为管理员',
        // 用户管理 end
        // 公告管理
        notice: '公告列表',
        notice1: '公告标题',
        notice2: '公告类型',
        notice3: '创建人',
        notice4: '创建日期',
        notice5: '新建公告',
        notice6: '公告标题',
        notice7: '公告正文',
        notice8: '编辑公告',
        // 公告管理 end
        // 部门管理
        depart1: '部门列表',
        depart2: '企业部门',
        depart3: '部门级别',
        depart4: '用户数',
        depart5: '部门编号',
        depart6: '下载表格',
        depart7: '上级部门',
        depart8: '昵称',
        depart9: '容量(M)',
        depart10: '用户编号',
        depart11: '增加部门',
        depart12: '查看',
        depart13: '部门用户列表',
        depart14: '部门结构',
        depart15: '身份',
        depart16: '排序字段',
        depart17: '排序方式',
        depart18: '是否激活',
        // 部门管理 end
        // 域管理员 (用户) end


        // 大系统
        url_a1_xie: '域名白名单',
        url_a2_xie: 'IP网段白名单',
        url_a3_xie: '一级域名',
        url_a4_xie: '转化列表',
        url_a5_xie: '非转化列表',
        url_a6_xie: '全局转化',
        url_a7_xie: '全局不转化',
        point: '分',
        second_rate: '次',
        as_good: '上报正常',
        as_spam: '上报垃圾',
        derived: '条数',
        up_mail: '当前已是第一封邮件',
        next_mail: '当前已是最后封邮件',
        up_mail1: '上一封',
        next_mail1: '下一封',
        zhu_info3_1: '病毒',
        zhu_info3_2: '钓鱼',
        zhu_info3_3: '色情',
        zhu_info3_4: '其他',
        zhu_info3_5: '广告',
        zhu_info3_6: '政治',
        zhu_info3_7: '总数',

        zhu_info2_1: '收件量',
        zhu_info2_2: '发件量',

        zhu_info1_1: '邮件数',
        zhu_info1_2: '拦截数',
        zhu_info1_3: '连接数',

        zhu_info1: '邮件统计图',
        zhu_info2: '收发统计图',
        zhu_info3: '垃圾分类图',
        zhu_info4: 'CPU占用图',
        out_login: '退出登录',
        time_login: '超时时间',
        time_login2: '超时时间(分钟)',
        time_login1: '设置超时时间',
        time_login3: '最小时间5分钟',
        welcome: '欢迎登录！',
        // URL隔离模块配置
        url_a1: 'URL隔离白名单',
        url_a2: '启用URL隔离',
        url_a3: '隔离添加UR',
        url_a4: 'URL或IP地址',
        url_a5: 'URL隔离默认策略',
        sender_query: '投递查询',
        sender_query1: '收件查询',
        Relay_target: '中继目标',
        // tls 策略管理
        tls_policy1: "是否启用强制TLS",
        tls_policy2: "强制TLS默认策略",
        tls_policy3: "强制TLS",
        // 管理员列表
        user_list1: '管理员列表',
        user_list2: '管理员',
        user_list3: '超级管理员',
        user_list4: '增加管理员',
        user_list5: '关联邮箱',
        user_list6: '密码',
        user_list7: '确认密码',
        user_list8: '允许登录IP',
        user_list9: '编辑管理员',
        shouye: '首页',
        // 系统信息
        sysyem_menu1: '硬盘信息',
        sysyem_menu2: '系统进程',
        sysyem_menu3: '处理器及内存信息',
        sysyem_menu4: '版本管理',
        sysyem_menu5: '规则及库管理',
        sysyem_menu6: '历史信息',
        // 归档管理  归档委派
        delegata1: "委派列表",
        delegata2: "委派给",
        delegata3: "增加委派",
        delegata3_edit: "编辑委派",
        // 策略组配置  策略优先级
        policyorder1: '策略优先级',
        policyorder2: '策略优先顺序',
        policyorder3: '策略名称',
        policy_matchcn: '匹配数',
        // 策略组配置  组级策略
        group1: '组级策略',
        group2: '过滤规则',
        group3: '收信个性化',
        group4: '发信个性化',
        group5: '增加策略组名',
        group6: '策略组名',
        group7: '域级策略',
        group7_c1: '策略域名',
        group7_c2: '所属域',
        group1_a1: '组成员设置',
        group1_a2: '组规则设置 ',
        group1_c2: '域规则设置 ',
        group1_e2: '用户规则设置 ',
        group1_a3: '组收信个性化设置',
        group1_c3: '域收信个性化设置',
        group1_e3: '用户收信个性化设置',
        group1_a4: '组发信个性化设置',
        group1_c4: '域发信个性化设置',
        group1_e4: '用户发信个性化设置',
        domain1: '输入查询域名',
        group7_a1: '所属组',
        group7_a2: '策略组所属部门',
        group7_a3: '策略组所属用户',
        group7_a4: '域名',
        group7_a5: '企业部门',
        group7_a6: ' 包含子部门',
        group7_a7: '所属域',
        group7_a8: '双向',
        group7_a11: '入方向',
        group7_a15: '主备',
        group7_a16: '轮询',
        group7_a12: '出方向',
        group7_a9: '系统默认',
        group7_b1: '组过滤规则',
        group7_b2: '组IP白名单',
        group7_b3: '组IP黑名单',
        group7_b4: '组from白名单',
        group7_b5: '组from黑名单',
        group7_b6: '添加组过滤规则',
        group7_b7: '添加组IP白名单',
        group7_b8: '添加组IP黑名单',
        group7_b9: '添加组from白名单',
        group7_b10: '添加组from黑名单',
        group7_ba1: '域过滤规则',
        group7_ba2: '域IP白名单',
        group7_ba3: '域IP黑名单',
        group7_ba4: '域from白名单',
        group7_ba5: '域from黑名单',
        group7_ba6: '添加域过滤规则',
        group7_ba7: '添加域IP白名单',
        group7_ba8: '添加域IP黑名单',
        group7_ba9: '添加域from白名单',
        group7_ba10: '添加域from黑名单',
        group7_bc1: '用户过滤规则',
        group7_bc2: '用户IP白名单',
        group7_bc3: '用户IP黑名单',
        group7_bc4: '用户from白名单',
        group7_bc5: '用户from黑名单',
        group7_bc6: '添加用户过滤规则',
        group7_bc7: '添加用户IP白名单',
        group7_bc8: '添加用户IP黑名单',
        group7_bc9: '添加用户from白名单',
        group7_bc10: '添加用户from黑名单',
        group7_c: '发件人策略',


        userLevel: '用户级策略',
        userLevel1: '增加策略用户',
        userLevel2: '策略用户',
        userLevel3: '所属用户',
        // 反垃圾配置  暗送配置
        bcc1: '暗送配置',
        bcc2: '添加暗送',
        bcc2_edit: '编辑暗送',
        bcc3: '暗送源地址',
        bcc4: '暗送类型',
        bcc5: '暗送目标地址',
        // 反垃圾配置  代理管理i
        proxy1: '代理参数',
        proxy2: '是否启用WEB代理',
        proxy3: 'WEB代理本地端口',
        proxy4: 'WEB代理目的地址',
        proxy5: '是否启用POP代理',
        proxy6: 'POP代理本地端口',
        proxy7: 'POP代理目标端口',
        proxy8: 'POP服务器地址',
        proxy9: '是否启用IMAP代理',
        proxy10: 'IMAP代理本地端口',
        proxy11: 'IMAP代理目标端口',
        proxy12: 'IMAP服务器地址',
        // 反垃圾配置  SNMP
        snmp1: 'SNMP参数',
        snmp2: 'SNMP允许连接IP',
        snmp3: 'SNMP共同体名',
        // 反垃圾配置  APT
        apt1: '沙箱开关',
        apt2: '沙箱设备配置',
        apt3: '沙箱扫描最大尺寸',
        apt4: '只有小于最大尺寸才会扫描,不建议超过20M',
        apt5: '是否开启沙箱扫描',
        apt6: '启用沙箱扫描,将针对恶意URL，短网址进行分析，对恶意附件进行分析',
        apt7: '沙箱观察模式',
        apt8: '沙箱观察模式下，邮件将不等待沙箱扫描，不等沙箱扫描先直接投递，扫描结果不影响邮件动作，只供观察',
        apt9: '设备登录用户',
        apt10: '登录用户密码',
        apt11: '设备ID号',
        apt12: '沙箱设备访问IP',
        apt13: '沙箱设备访问端口',

        // 反垃圾配置  DKIM 和 DMARC
        dkim1: '基本参数',
        dkim2: 'DKIM域名密钥',
        dkim3: 'DKIM信任主机',
        dkim1_a1: '启用DKIM签名',
        dkim1_a2: '对于有签名权限的域名、服务器发送邮件时，进行DKIM签名',
        dkim1_a3: '启用DKIM验证',
        dkim1_a4: '对于外部发进来的邮件，进行dkim验证',
        dkim1_a5: '启用DMARC验证',
        dkim1_a6: '对于外部发进来的邮件，启用DMARC验证，特别注意：启用DMARC时需启用DKIM验证',
        dkim1_a7: '添加签名秘钥',
        dkim1_a8: '签名域名',
        dkim1_a9: 'DKIM选择器',
        dkim1_a10: '公共密钥',
        dkim1_a11: '添加信任主机',
        dkim1_a12: 'DKIM信任主机',
        tempalte_adm: '模板管理',
        tempalte_adm_name: '模板名称',
        tempalte_adm_notify: '通知主题',
        tempalte_adm_content: '通知内容',
        tempalte_adm_acc: '原邮件作为附件',
        tempalte_adm_add: '添加模板管理',
        tempalte_adm_edit: '编辑模板管理',
        // 反垃圾配置  灰名单管理
        greylist1: '灰名单设置',
        greylist2: '启用灰名单',
        greylist3: '连接灰名单服务超时(秒)',
        // 反垃圾配置  附件解析管理
        attachment1: '附件解析设置',
        attachment2: '启用附件解析',
        attachment3: '附件解析的附件数量',
        attachment4: '附件解析超时时间(秒)',
        attachment5: '附件解析最大单个附件大小(KB)',
        attachment6: '附件解析最大邮件大小(KB)',
        attachment7: '附件解析邮件中最大附件数',
        attachment8: '设置解析邮件中的前几个附件的数量',
        attachment9: '解析时间超过设置时间后将直接跳过该附件解析',
        attachment10: '当单个附件大小超过设置值时，不对该附件进行内容解析',
        attachment11: '当邮件大小超过设置值时，不对该邮件进行附件内容解析',
        attachment12: '当邮件中的附件，大于设置的数量时，不对该邮件进行附件内容解析',
        // 反垃圾配置  智能学习管理
        smartLearn1: '参数设置',
        smartLearn2: '个性化设置',
        smartLearn3: '正常列表',
        smartLearn4: '垃圾列表',
        smartLearn5: '启用智能学习过滤',
        smartLearn6: '智能学习最大邮件大小(KB)',
        smartLearn7: '添加智能学习个性化',
        smartLearn8: '邮箱账号或IP地址',
        smartLearn9: '学习正常邮件',
        smartLearn10: '学习垃圾邮件',
        snpm: 'SNMP允许连接IP',
        snpm1: 'SNMP共同体名',
        // 反垃圾配置  IP黑名单认证管控
        blackip1: '认证IP黑名单检查策略',
        blackip2: '认证IP黑名单默认策略',
        // 反垃圾配置  SMTP发信IP管控
        smtpIp1: '系统SMTP发信默认管控策略',
        smtpIp2: '系统允许SMTP发信IP范围',
        smtpIp3: '账号允许SMTP发信IP范围',
        smtpIp4: '默认SMTP发信管控策略',
        smtpIp5: '添加账号的SMTP发信管控策略',
        smtpIp5_edit: '编辑账号的SMTP发信管控策略',
        smtpIp6: ' 类型',
        smtpIp7: ' 添加允许SMTP发信IP',
        smtpIp7_edit: ' 编辑允许SMTP发信IP',
        smtpIp8: ' 添加账号允许SMTP发信IP范围',
        smtpIp8_edit: ' 编辑账号允许SMTP发信IP范围',
        smtpIp9: ' 账号',
        smtpIp4_four: 'SMTP免认证IP范围',
        smtpIp4_four_add: '添加SMTP免认证IP范围',
        smtpIp4_four_edit: '编辑SMTP免认证IP范围',
        // 反垃圾配置  异常及滥发管理
        abnorMal1: '异常账号默认',
        abnorMal2: '弱密码判定默认',
        abnorMal3: '异常账号个性化',
        abnorMal4: '弱密码判定个性化',
        abnorMal5: '弱密码库管理',
        abnorMal6: '内容滥发管理',
        abnorMal7: '编辑异常账号默认设置',
        abnorMal8: '判定类型',
        abnorMal9: '判定值',
        abnorMal10: '编辑弱密码判定默认设置',
        abnorMal11: '类型说明',
        abnorMal12: '添加异常账号个性化设置',
        abnorMal12_edit: '添加异常账号个性化设置',
        abnorMal13: '添加弱密码判定个性化设置',
        abnorMal13_edit: '编辑弱密码判定个性化设置',
        abnorMal14: '添加弱密码',
        abnorMal15: '批量添加弱密码',
        abnorMal16: '导入弱密码',
        abnorMal17: '导出弱密码',
        abnorMal18: '弱密码',
        abnorMal19: '添加基于用户的内容滥发默认动作',
        abnorMal19_edit: '编辑基于用户的内容滥发默认动作',
        abnorMal20: '配置滥发阅读邮件URL',
        abnorMal21: '基于用户的内容滥发默认动作',
        abnorMal22: '滥发次数',
        // 反垃圾配置  ldap
        // 反垃圾配置  ldap
        ldap1: '域策略',
        ldap2: '域默认动作',
        ldap3: '收件人列表及设置',
        ldap4: 'LDAP收件人检查',
        ldap5: 'LDAP域名配置',
        ldap6: '字典攻击配置',
        ldap7: '输入查询域名',
        ldap8: '查询',
        ldap9: '检查策略说明',
        ldap10: '收件人检查策略',
        ldap11: '检查动作说明',
        ldap12: '收件人检查动作',

        ldap13: '输入查询账号',
        ldap14: '添加用户',
        ldap14_edit: '添加用户',
        ldap15: '批量增加用户',
        ldap16: '批量导入用户',
        ldap17: 'LDAP收件人检查',
        ldap18: '添加LDAP配置',
        ldap18_edit: '编辑LDAP配置',
        ldap19: 'LDAP服务器主机',
        ldap20: '验证',
        ldap21: '编辑',
        ldap22: '添加域名',
        ldap23: '域名',
        ldap24: '字典攻击开关',
        ldap25: '启用字典攻击检查，将对发送错误的收件人进行数量检查',
        ldap26: '最大错误收件人数',
        ldap27: '一定周期内(4小时)当错误收件人数达到最大设置的值时，将对其进行拦截',
        ldap28: '错误收件人延迟响应时间',
        ldap29: '当邮件中含有错误收件人延迟响应时间,0表示不延迟，最大不超过3s',
        ldap30: 'DMARC个性化策略',
        ldap31: 'DMARC默认检查策略',
        ldap32: '添加DMARC策略',
        ldap32_edit: '编辑DMARC策略',
        ldap33: 'LDAP用户同步',
        ldap34: '使用LDAP收件人检查相同配置',
        ldap35: '手动同步',
        ldap36: '设置定时同步',
        ldap37: '定期同步时间点',
        ldap38: 'LDAP用户同步配置',
        ldap39: '单个会话最大错误收件人数',
        ldap40: '当单个会话中错误收件人数量达到设定值时是否拒绝,0表示不拒绝',

        // 反垃圾配置  系统收发控制
        frequency1: 'smtp频率管控',
        frequency1_add: '添加免频率限制IP',
        control1: '本地默认控制',
        control2: '外部默认控制',
        control3: 'IP默认控制',
        control4: '本地控制',
        control5: '外部控制',
        control6: 'IP控制',
        control7: '禁止用户发信',
        control8: '禁止IP发信',
        control9: '修改本地账户系统默认控制',
        control10: '控制类型',
        control11: '控制数量',
        control12: '修改外部账户系统默认控制',
        control13: '修改IP默认控制',
        control14: '设置本地账户的外发控制',
        control14_edit: '编辑本地账户的外发控制',
        control15: '设置外部账户的外发控制',
        control15_edit: '设置外部账户的外发控制',
        control16: '设置IP地址的外发控制',
        control16_edit: '编辑IP地址的外发控制',
        control17: '添加禁止发信账户',
        control18: '添加禁止发信IP',
        // 反垃圾配置  个性化策略
        policy1: '发件人策略',
        policy2: '收件人策略',
        policy3: 'IP策略',
        policy4: '已设置策略列表',
        policy5: '输入信封发件人或域',
        policy6: '获取设置对象当前策略',
        policy7: '过滤手段',
        policy8: '描述',
        policy9: '默认设置',
        policy10: '输入信封收件人或域',
        policy11: '输入连接IP',
        policy12: '对象类型',
        policy13: '配置对象',
        policy14: '过滤动作',
        // 反垃圾配置  过滤器
        filter1: '过滤器列表',
        filter2: '添加过滤器',
        filter3: '过滤器名称',
        filter4: '过滤器描述',
        filter5: '被引用数',
        filter6: '创建时间',
        filter7: '最近更新时间',
        filter8: '显示宏列表',
        filter9: '隐藏宏列表',
        filter10: '编辑过滤器',

        Conditional1: '启用条件策略',
        Conditional2: '与',
        Conditional3: '或',
        Conditional4: '条件块',
        Conditional5: '添加条件块',
        Conditional6: '删除条件块',
        Conditional7: '添加',
        Conditional8: '删除',
        Conditional9: '单元内规则关系',
        Conditional10: 'URL包含收件人',
        Conditional11: '预制条件检查',
        Conditional12: 'URL黑名单检查',
        Conditional13: 'URL解析IP检查',

        Content1: '启用内容策略',
        Content2: '内容块',
        Content3: '添加内容块',
        Content4: '删除内容块',
        Content5: '分数',
        Alink1: '启用A链接扫描',
        Alink2: 'A链接块',
        Alink3: '添加A链接块',
        Alink4: '删除A链接块',
        // 反垃圾配置  SPF配置
        spf1: '增加SPF白名单IP',
        spf2: '导入SPF白名单IP',
        spf3: '导出SPF白名单IP',
        spf4: '增加SPF白名单账号',
        spf5: '导入SPF白名单账号',
        spf6: '导出SPF白名单账号',
        spf8: 'SPF白名单账号',
        spf7: 'SPF白名单IP',
        // 反垃圾配置  过滤策略
        Policy_list1: '过滤策略',
        Policy_list_white: '超级白名单策略',
        Policy_list2: '添加策略',
        Policy_list17: '编辑策略',
        Policy_list3: '策略名称',
        Policy_list4: '过滤器',
        Policy_list5: '组合单元',
        Policy_list6: '过滤动作',
        Policy_list7: '备注说明',
        Policy_list8: '方向',
        Policy_list9: '激活',
        Policy_list10: '中心节点',
        Policy_list11: '离线规则禁用',
        Policy_list12: '允许设置不检查',
        Policy_list13: '策略类型',
        Policy_list14: '优先级',
        Policy_list15: '到期时间',
        Policy_list16: '创建时间',
        Policy_list18: '区域分配',
        Policy_list19: '操作权限',
        Policy_list20: '设置可管理区域对象',
        Policy_list21: '管理员',
        Policy_list22: '保存时间(天)',
        Policy_list23: '自定义',
        Policy_list24: '时',
        Policy_list25: '分',
        strategy_group: "策略组",
        strategy_group_list: "策略列表",
        strategy_group_add: "新增策略组",
        strategy_group_edit: "编辑策略组",
        strategy_group_admin: "策略组管理",
        strategy_group_admin_control: "针对区域邮件的操作权限",
        Policy_list_son: '新增子策略',
        Policy_list_son_new: '子策略',
        Policy_list_son_edit: '编辑子策略',
        policy_group_name: "当前策略组名称",

        regional_authority: "区域管理",
        regional_authority1: "添加区域",
        // 反垃圾配置  组合策略
        Policy_unit: '过滤单元',
        Policy_comb: '过滤组合',
        Regex_test: '正则表达式测试',
        disclaimer: "免责声明",
        disclaimer1: "免责内容",
        disclaimer_new1: "免责声明html内容(UTF-8)",
        disclaimer_new2: "免责声明html内容(en_us)",
        disclaimer_new3: "免责声明plain内容(UTF-8)",
        disclaimer_new4: "免责声明plain内容(en_us)",
        prompt_statement: '风险提示',
        prompt_statement_show: '默认风险提示是否开启',
        prompt_statement_table: '风险提示是否开启',
        hint_new1: "风险提示html内容(UTF-8)",
        hint_new2: "风险提示html内容(en_us)",
        hint_new3: "风险提示plain内容(UTF-8)",
        hint_new4: "风险提示plain内容(en_us)",
        disclaimer3: "纯英文免责内容",
        disclaimer2: "是否启用",
        disclaimer_daf: "默认免责是否开启",
        disclaimer_daf1: "个性化提示",
        disclaimer_daf1_add: "新增个性化提示",
        disclaimer_daf1_daf: "免责是否开启",

        disclaimer4: "保存归档是否添加",
        disclaimer5: "本地域名发信是否添加",
        Policy_unit1: '增加过滤单元',
        Policy_unit1_edit: '编辑过滤单元',
        Policy_unit2: '过滤单元名称只能为纯字母+数字的组合，不能添加其他符号，且一个单元只能对应一个过滤类型',
        Policy_unit3: '过滤单元类型',
        Policy_unit4: '过滤单元名称',
        Policy_unit5: '备注说明',
        Policy_unit6: '单元内规则关系',
        Policy_unit7: '子项数目',
        Policy_unit8: '被引用数',
        Policy_unit9: '创建时间',
        Policy_comb1: '名称',
        Policy_comb2: '规则',
        Policy_comb3: '方向',
        Policy_comb4: '过滤动作',
        Policy_comb5: '激活',
        Policy_comb6: '中心节点',
        Policy_comb7: '检查',
        Policy_comb8: '策略类型',
        Policy_comb9: '到期时间',
        Policy_comb_select: '可选动作',
        Policy_comb12: '是',
        Policy_comb13: '否',
        Policy_comb10: '过滤组合是将设置的过滤单元，按照与、或、非的关系组合在一起，形成一个组合过滤规则',
        Policy_comb11: '增加过滤组合',

        Policy_comb11_edit: '编辑过滤组合',
        Regex_test1: '输入匹配文本',
        Regex_test2: '正则表达式',
        Regex_test3: '匹配结果',
        Regex_test4: '测试匹配',
        Regex_test5: '关键词',
        // 组合策略 发件人
        to_envfrom_sender: '导入发件人',
        export_envfrom_sender: '导出发件人',
        to_envfrom_rec: '导入收件人',
        export_envfrom_rec: '导出收件人',
        to_envfrom_ip: '导入ip地址',
        export_envfrom_ip: '导出ip地址',
        Policy_unit_sender1: '发件人',
        Policy_unit_sender2: '添加发件人',
        Policy_unit_sender3: '批量添加',
        Policy_unit_sender4: '添加单元内发件人列表，单元名称：usender,单元内规则关系:或',
        Policy_unit_sender5: '单元内域名或邮箱',
        Policy_unit_sender6: '类型',
        Policy_unit_Recipient1: '收件人',
        Policy_unit_Recipient2: '添加收件人',
        Policy_unit_Recipient3: '添加单元内收件人列表，单元名称：urcpt,单元内规则关系:或',
        Policy_unit_ip1: 'ip地址',
        Policy_unit_ip2: '添加ip地址',
        Policy_unit_regex1: '过滤规则',
        Policy_unit_regex2: '添加过滤规则',
        Policy_unit_regex2_edit: '编辑过滤规则',
        Policy_unit_regex3: '表达式类型',
        Policy_unit_regex4: '信头key',
        Policy_unit_regex5: '单元内过滤规则',
        Policy_unit_regex6: '规则类型',
        Policy_unit_rule: '单元条件规则设置',
        Policy_unit_rule_msgsize: '邮件尺寸',
        Policy_unit_rule_bodysize: '正文尺寸',
        Policy_unit_rule_attsize: '附件尺寸',
        Policy_unit_rule_attnum: '附件数量',
        Policy_unit_rule_rcptnum: '收件人数量',
        Policy_unit_rule_outrcptnum: '外部收件人数',
        Policy_unit_rule_bsrcptnum: '大站点收件人数',
        Policy_unit_rule_bccnum: '暗送收件人数',
        Policy_unit_rule_Checkwhite: '白名单检查',
        Policy_unit_rule_Timerange: '时间范围',
        Policy_unit_rule_Checknettype: '网络类型检查',
        Policy_unit_rule_Checkfrom: '发件人检查',
        Policy_unit_url1: 'URL地址',
        Policy_unit_url2: '添加URL地址',
        Policy_unit_url3: 'Url解析IP',
        Policy_unit_url4: '添加Url解析IP',
        Policy_back: '返回',
        // 6数据统计排行   报表及排程管理
        report1: '报表定制',
        report2: '排程定制',
        report3: '发信',
        report4: '收信',
        report5: '排行',
        report6: '融合数据',
        report7: '本地用户',
        report8: '外部用户',
        report9: '本地域',
        report10: '外部域',
        report11: 'IP',
        report12: 'IP段',
        report13: '全选',
        report14: '其他',
        report15: '打印条数',
        report16: '下载',
        report17: '接收邮箱',
        report18: '时间',

        // 6数据统计排行   规则匹配统计
        statRule1: '规则匹配',
        statRule2: '组合策略匹配',
        statRule3: '新策略匹配',
        statRule4: '组策略匹配',
        statRule1_a1: '规则类型',
        statRule1_a2: '规则表达式',
        statRule1_a3: '规则分数',
        statRule1_a4: '匹配次数',
        statRule1_a5: '新策略匹配',
        statRule1_a6: '最近匹配时间',
        statRule1_a7: '组合策略名称',
        statRule1_a8: '新策略名称',
        statRule1_a9: '匹配策略',
        statRule1_a10: ' 是否匹配',
        topic_statistical: ' 主题统计',
        topic_statistical_title: ' 主题',

        // 数据统计排行   用户发信，收信
        loacalsendmsg1: '邮件数',
        loacalsendmsg2: '大站点数',
        loacalsendmsg3: '字节数',
        loacalsendmsg4: '收件人数',
        loacalsendmsg5: '对外域消息',
        loacalsendmsg6: '对外域收件人',
        loacalsendmsg7: '对外域字节数',
        loacalsendmsg8: '外域邮件数',
        loacalsendmsg9: '来自大站点邮件数',
        loacalsendmsg10: '外域字节数',
        loacalsendmsg11: '退信数',
        loacalsendmsg12: '拒绝数',
        loacalsendmsg13: '连接数',
        loacalsendmsg14: '认证成功数',
        loacalsendmsg15: '认证失败数',
        loacalsendmsg_a1: '显示条数',
        loacalsendmsg_a2: '时间区间',


        loacalsendmsg1_a1: '数量',
        loacalsendmsg1_a2: '最近行为发生时间',
        loacalsendmsg1_a3: '24小时明细',
        loacalsendmsg1_a4: '发信记录',
        loacalsendmsg1_a8: '收信记录',
        loacalsendmsg1_a5: '实时日志',
        loacalsendmsg1_a6: '搜索归档 ',
        loacalsendmsg1_a7: '各项详情 ',

        // 数据统计排行   数据统计
        statistics1: '查询最近两年的全局统计数据 ',
        statistics2: '下载统计数据',
        statistics3: '时间',
        statistics4: '连接数量',
        statistics5: '邮件数量',
        statistics6: '总拦截数',
        statistics7: '收件人数',
        statistics8: '病毒数',
        statistics9: 'ip黑名单',
        statistics10: 'SPF拦截',
        statistics11: '收件人未知',
        statistics12: '字节数',
        statistics13: '数据统计',
        statistics14: '当天统计',
        statistics15: '子项',
        statistics16: 'Total',
        statistics17: '恶意邮件',
        statistics18: '钓鱼',
        statistics19: '区域管理列表',
        statistics_list: '区域列表',
        statistics20: '策略详情列表',
        statistics_table: '表格展示',
        statistics_chart: '图表展示',
        // 系统配置   集群管理
        colony1: '集群主设置',
        colony2: '集群从设置',
        colony3: '集群列表',
        colony1_a1: '是否启用集群主节点',
        colony1_a2: '启用集群主节点后，将统一管理所有添加的从服务器',
        colony1_a3: '集群主节点IP地址',
        colony1_a4: '设置集群主节点的IP地址，必须为本机的IP地址且与从节点的IP能够互通',
        colony2_a1: '是否启用集群从节点',
        colony2_a2: '启用集群从节点后，所有配置项信息都将隐藏，只能从主节点配置',
        colony2_a3: '集群从节点IP地址',
        colony2_a4: '设置集群从节点的IP地址，必须为本机的IP地址且与主节点的IP能够互通',
        colony3_a1: '添加集群主机',
        colony3_a2: '集群状态',
        // 系统配置   补丁升级
        patch1: '系统补丁升级',
        patch2: '上传补丁包',
        patch3: '补丁升级',
        // 系统配置   系统服务
        system1: '管理系统服务',
        system2: '系统服务',
        system3: '当前状态',
        system4: '启动',
        system5: '停止',
        // 系统配置   配置双机热备
        HASetting1: '配置双机热备',
        HASetting2: '启动双机热备服务',
        HASetting3: '广播地址',
        HASetting4: '设置广播地址，为对方ip',
        HASetting5: '漂移地址',
        HASetting6: '在业务口配置对外漂移地址及子网掩码',
        HASetting7: 'ping地址',
        HASetting8: '一般设置为ping网络网关地址，如果为心跳直连线方式，则可以不设置',
        HASetting9: '主节点主机名',
        HASetting10: '从节点主机名',
        HASetting11: '作为主节点',
        // 系统配置   配置防火墙
        firewall1: '默认全局策略',
        firewall2: '规则列表',
        firewall1_a1: '启动防火墙',
        firewall1_a1_a1: '防火墙当前状态为关闭中',
        firewall1_a1_a2: '防火墙当前状态为开启中',
        firewall1_a_2: '关闭防火墙',
        firewall1_a2: '入方向',
        firewall1_a3: '出方向',
        firewall1_a4: '是否可转发',
        firewall1_a5: '对外放开访问的端口',
        firewall1_a6: '受限端口',
        firewall1_a7: '17951,启用ssh端口访问限制以保障系统安全,防火墙启动后，只有设置了的IP进行SSH访问',
        firewall1_a8: '限制http访问',
        firewall1_a9: '默认http允许外部访问，如果勾选此选项，则禁止外部访问80web端口,请勾选之前，设置可允许访问的IP段',
        firewall1_a10: '限制https访问',
        firewall1_a11: '默认https允许外部访问，如果勾选此选项，则禁止外部访问443web端口,请勾选之前，设置可允许访问的IP段',
        firewall2_a1: '添加规则',
        firewall2_a2: '方向',
        firewall2_a3: '类型',
        firewall2_a4: '协议',
        firewall2_a5: '端口',
        firewall2_a6: '远端',
        firewall2_a7: '规则',
        firewall2_a8: '允许',
        firewall2_a9: '限制',
        firewall2_a10: '源IP地址',
        firewall2_a11: '入方向',
        firewall2_a12: '出方向',
        // 系统配置   网络配置
        network1: '网络配置',
        network2: '网络代理',
        network3: '网络测试',
        network1_a5: 'ip地址(v4)',
        network1_a5_v6: 'ip地址(v6)',
        network1_a6: '网卡名称',
        network1_a1: '子网掩码(v4)',
        network1_a2: '网关地址(v4)',
        network1_a2_v6: '网关地址(v6)',
        network1_aa_v6: '启用(v6)',
        network1_a3: 'DNS1',
        network1_a4: 'DNS2',
        network2_a1: '代理地址',
        network2_a2: '代理端口',
        network2_a3: '代理账号',
        network2_a4: '代理密码',
        network3_a1: '测试程序',
        network3_a2: '主机名或IP地址',
        network3_a3: '解析类型',
        network3_a4: '运行结果',
        network3_a5: '运行',
        network3_a6: '测试端口',
        network3_a7: '测试条数',

        // 系统配置   网关认证配置
        autu1: 'SMTP认证',
        autu2: 'POP3认证',
        autu3: 'IMAP认证',
        autu4: 'AD认证',
        autu5: '认证测试',
        autu6: '认证控制',
        autu1_a1: '启用SMTP认证方式，用户在网关进行SMTP发信认证时，网关会以SMTP方式向SMTP服务器发起认证',
        autu1_a2: 'SMTP服务器',
        autu1_a7: '如选中，则NTLM认证机制强制采用Email地址前半部分进行认证(适用于特定的Exchange版本认证机制)',

        autu1_a3: '可以配置多个认证地址，用逗号分开，可以针对域名单独指定认证服务器地址(适用于针对多域多邮件服务器的防护)',
        autu1_a4: 'SMTP服务器端口',
        autu1_a5: 'EHLO主机名',
        autu1_a6: 'SMTP认证机制',
        autu2_a1: '启用POP3认证方式，用户在网关进行SMTP发信认证时，网关会以POP3方式向POP服务器认证',
        autu2_a2: 'POP3服务器',
        autu2_a3: 'POP3服务器端口',
        autu2_a4: 'SSL',
        autu3_a1: '启用IMAP认证方式，用户在网关进行SMTP发信认证时，网关会以IMAP方式向IMAP服务器认证',
        autu3_a2: 'IMAP服务器',
        autu3_a3: 'IMAP服务器端口',
        autu4_a1: '启用LDAP认证方式，用户在网关进行SMTP发信认证时，网关会以LDAP方式向LDAP服务器认证',
        autu4_a2: 'LDAP服务器',
        autu4_a3: 'LDAP服务器端口',
        autu4_a4: 'Search Base',
        autu4_a5: 'Bind DN',
        autu4_a6: 'PASSWORD',
        autu5_a1: '测试会对已经启用的认证方式进行测试，请确认已经启用了其中一种认证，并正确配置了该认证方式的各个参数',
        autu5_a2: '邮箱账号',
        autu5_a3: '密 码',
        autu5_a4: '开始测试',
        autu6_a1: '添加认证信任IP',
        autu6_a2: '认证失败周期',
        autu6_a3: '分钟',
        autu6_a4: '认证失败次数',
        autu6_a5: '设置相同IP的认证失败周期，不能低于1分钟大于30分钟，周期内达到失败次数则拒绝认证',

        // 系统配置   基本配置
        base1: '邮件传送',
        base2: '默认域名',
        base3: '中继域名',
        base4: '本地域名',
        base5: '路由设置',
        base_address: '发件人路由',
        base6: 'TLS设置',
        base7: '时间设置',
        base8: '后台访问控制',
        base9: 'License管理',
        base10: '证书管理',
        base1_a1: '当前邮件传送信任的所有IP',
        base1_a2: '请输入邮件传送可信任IP',
        base1_a3: '是否配置该参数',
        base1_a4: '添加信任IP',
        base1_a4_edit: '编辑信任IP',
        base1_a5: '域名设置',
        base1_a6: '当前域名',
        base1_a7: '输入域名',
        base1_a8: '当前主机名',
        base1_a9: '输入主机名',
        base1_a10: '网关对外的SMTP IP必须加入，此外可以增加邮件传送无条件信任的其他IP，如邮件服务器的IP',
        base1_a11: '选中，则进行信任IP的增删，不选，则信任IP该项配置不作变动',
        base1_a12: '系统唯一默认域名，对于没有设置@后面的本地Email地址，均按该域名下用户处理',
        base1_a13: '对外SMTP会话的HELO主机名，建议主机名能正确解析到网关外网IP',
        base2_a1: '当前反垃圾默认域名',
        base2_a2: '域名',
        base2_a3: '当前认证默认域名',
        base3_a1: '配置允许中继域名',
        base3_a3: '添加中继域名',
        base3_a2: '中继域名被允许通过反垃圾网关进行中继转发，邮件服务器的域名必须被设置到中继域名列表',
        base4_a1: '配置本地域名',
        base4_a3: '添加本地域名',
        base4_a2: '反垃圾将该列表中的所有域名，视同本地域处理',
        base5_a1: '设置路由',
        base5_a6: '添加路由',
        base5_a2: '设置路由，网关到邮件服务器的路由必须设置',
        base5_a3: '	路由地址',
        base5_a3_sender: '发件人地址',
        base5_a4: '路由目标地址',
        base5_a5: '路由端口',
        base5_a7: '支持填写多个路由目标地址，多个地址中间使用逗号隔开',
        base5_a8: '路由模式',
        base5_a9: '编辑路由',
        base6_a1: '设置TLS',
        base6_a5: '添加TLS',
        base6_a2: '针对目的域名地址设置TLS',
        base6_a3: '	TLS地址',
        base6_a4: 'TLS类型',
        base7_a1: '系统时间',
        base7_a2: '手动设置',
        base7_a3: 'NTP 服务器',
        base7_a4: '手动设置时间',
        base7_a5: '立即同步',
        base8_a1: '启用',
        base8_a2: '启用后，只有指定IP范围的机器才能访问系统,否则面向全部IP开放',
        base8_a3: '设置可访问IP范围',
        base8_a4: 'IP可以设置ip段和最终IP，用逗号分开，如12.12,122.122.2.2等',
        base8_a5: '只有启用后，设置好的特权IP才能进行对应特权操作，如关机，重启，配置网络等重大操作,否则任何IP都无权执行类似操作',
        base8_a6: '设置特权IP范围',
        base8_a7: '特权IP可以操作关机，重启，网络配置等基础应用',
        base8_a8: '最大登录错误次数',
        base8_a9: '管理员登录密码错误次数超到设定值时，将锁定账户一段时间',
        base8_a10: '登录错误限制时间',
        base8_a11: '管理员登录锁定的时间周期，单位为秒',
        base9_a1: '当前license到期时间',
        base9_a2: '服务器MAC地址',
        base9_a3: '许可证序列号',
        base9_a4: '更新License',
        base10_a1: '上传证书',
        base10_a2: '自建证书',
        base10_a3: '目前导入证书，只支持导入crt、pem和pfx格式的证书，暂不支持其他格式',
        base10_a4: '域名',
        base10_a5: '颁发机构',
        base10_a6: '证书创建时间',
        base10_a7: '证书到期时间',
        base10_a8: '公司名称',
        base10_a9: '部门',
        base10_a10: '城市',
        base10_a11: '省/直辖市',
        base10_a12: '国家',
        base10_a13: '国际标准组织ISO国码2位国家代号',
        base10_a14: '年',
        base10_a15: '证书格式',
        base10_a16: '证书文件',
        base10_pass: '证书密码',
        base10_a17: '证书私钥',
        base10_a18: '配置证书',



        // 垃圾病毒   隔离管理通知
        notifyman1: '隔离邮件通知设置',
        notifyman2: '排除账号列表',
        notifyman3: '指定账号列表',
        notifyman4: '别名账号列表',
        notify1: '隔离通知管理默认域名',
        notify2: '隔离网关web地址',
        notify3: '隔离定期发送点',
        notify4: '隔离邮件链接有效天数',
        notify5: '通知策略选项',
        notify6: '启用',
        notify7: '域名或邮箱账号',
        notify8: 'Email',
        notify9: '别名',
        notify10: '添加排除账号',
        notify11: '添加指定账号',
        notify12: '添加别名账号',
        notify13: '自定义隔离通知',
        notify13_add: '自定义添加',
        notify13_edit: '自定义编辑',
        notify13_policy: '通知策略选项',
        notify13_notice_time: '定点通知时间',
        notify_state1: '默认域名设置后将以postmaster@默认域名发送通知，如果不配置，则以收件人后缀作为对应域名',
        notify_state2: '隔离邮件下载地址，http://内网或者外网IP:端口，也可以配置域名，通过dns内外网均可访问',
        notify_state3: '发送时间，一天一次或者2次，指定特定小时每天发送，如8表示早上8点定期发送，两次的话用冒号隔开，如8:16，8点和16点分别发送一次',
        notify_state4: '发送通知中每一封隔离垃圾邮件允许保留可操作的最大天数，超过该天数，隔离链接将失效无法打开,设置不能低于7天，最大不允许超过30天',
        notify_state5: '可设置排除部分账号不发送隔离邮件通知，或指定发送给某些账号，默认全部发送',
        notify_state6: '是否启用隔离通知，关闭则不发送通知',
        // 审核区邮件
        auditlist: '审核区邮件',
        auditlist1: '审核状态',
        // 审核策略
        save_a: '保存',
        save_verify: '验证',
        save_b: '取消',
        audit: '审核流程',
        audit1: '审核策略名称',
        audit2: '审核员',
        audit3: '编辑流程',
        audit4: '编辑策略',
        audit5: '增加审核流程',
        audit6: '操作',
        audit7: '审核策略规则',
        audit8: '反垃圾配置组合策略中设置的过滤单元,按照与、或、非的关系组合,形成一个审核策略规则',
        // 延迟投递区
        defer: '延迟投递列表',
        defer1: '延迟时间',
        defer2: '状态',
        defer3: '等待投递',
        defer4: '已投递',
        defer5: '取消投递',
        // 管理日志
        manage01: '管理日志',
        manage: '查询管理日志',
        manage1: '时间',
        manage2: '管理员',
        manage3: 'ip地址',
        manage4: '动作',

        // 异常账号
        qing_a: '确认清除？',
        qing_a1: '清除成功？',
        qing_a2: '已取消？',
        removeabus: '解封账号',
        abnuser: '异常账号',
        weakp: '弱口令账号',
        weakp1: '弱口令原因',
        contab: '内容滥发账号',
        expabe: '导出异常账号',
        currente: '当前主机异常账号',
        claerwu: '清除弱口令账号列表',
        claerwu1: '导出弱口令账号',
        claerwu2: '当前主机弱密码账号',
        clearcon: '清空内容滥发账号',
        clearcon1: '导出内容滥发账号',
        shuo1: ' 以下为系统监测到的行为异常账号列表，请管理员确认，如确认为行为异常，请及时通知用户更改密码！',
        shuo2: '以下为系统监测到的弱口令账号列表，请管理员及时通知用户更改密码！',
        shuo3: '以下为系统监测到的内容滥发次数达到滥发次数限制的账号列表，请确认是否为滥发，并及时通知用户更改密码',
        addt: '添加时间',
        // 当前SMTP连接
        smtpc: '当前SMTP连接',
        xuhao: '序号',
        ip: 'IP',
        connect: '连接数量',
        xuhao1: '以下为正在与系统SMTP连接的IP地址，及连接数量',
        xuhao2: '当前SMTP总连接IP数',
        xuhao3: '当前总连接会话数',

        // 当前队列
        Queue: '实时队列管理',
        clearAll: '清空全部队列',
        clearDef: '清空推迟队列',
        resAll: '重投所有队列',
        query: '查找队列',
        chongFa: '重发',
        sender: '发件人',
        recipient: '收件人',
        Queueid: '队列ID',
        Queuetotal: '队列总数',
        Queuetotal1: '红色队列表示正在发送，黑色队列表示发送失败，在队列中等待系统调度重新重新投递，也可手动立即重投',
        ressequ: '重投所选队列',
        ressequ1: '删除所选队列',
        kuaifa: '确定将队列立即重新投递吗',
        kuaifa1: '重新投递成功',
        kuaifa2: '已取消',
        kuaifa3: '清空成功',
        kuaifa4: '查找成功',
        kuaifa5: '取消查找',
        qing1: '清空队列，将把所有队列邮件清空，并且不可恢复，您确定要做这个操作？',
        qing2: '清空deferred(延迟排队)队列，并且不可恢复，您确定要做这个操作？',
        qing3: '确定将队列全部重投吗?',
        qing4: '确定重投所有选中的队列?',
        qing5: '确定删除所有选中的队列？',
        qing6: '请至少选择一个队列',
        sand4_1: '邮件主题',
        sand4_2: '发件人',
        sand4_3: '收件人',
        sand4_4: '集群节点',
        sand4_5: 'MTA',



    }

}